document.addEventListener(
  "click",
  function (e) {
    const btn = e.target.closest(".sticky-add-to-cart__button[data-external-link]");
    if (!btn) return;

    const url = btn.getAttribute("data-external-link");
    if (!url) return;

    // Beat Ritual's handler
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === "function") e.stopImmediatePropagation();

    window.open(url, "_blank", "noopener");
  },
  true
);
